module.exports = __webpack_public_path__ + "static/media/question-circle.6c89a69e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/question-circle.svg
// module id = 2715
// module chunks = 0